import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, ResolveEnd, ResolveStart, RouteConfigLoadStart, Router, Event } from '@angular/router';
import { NgxSpinnerService, Spinner } from 'ngx-spinner';
import { fromEvent, map, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  readonly showScroll$: Observable<boolean> = fromEvent(this.document, 'scroll').pipe(map(() => this.viewport.getScrollPosition()?.[1] > 0));

  private appSpinnerOptions: Spinner = {
    bdColor: 'rgba(255, 255, 255, 1)',
    color: 'rgba(0, 0, 0, .5)'
  };

  // Subscriptions
  private subscription: Subscription = new Subscription();

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly viewport: ViewportScroller,
    private router: Router,
    private spinner: NgxSpinnerService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon('warn', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/warn-icon.svg'));
    this.matIconRegistry.addSvgIcon('err', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/err-icon.svg'));
    this.matIconRegistry.addSvgIcon('save_spectra', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/save_spectra-icon.svg'));

    this.spinner.show('app-spinner', this.appSpinnerOptions);

    this.subscription.add(
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationStart || event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
          this.spinner.show('app-spinner');
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError || event instanceof ResolveEnd) {
          this.spinner.hide('app-spinner');
          this.onScrollToTop();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * @description On scroll to top
   */
  onScrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
